module.exports = __webpack_public_path__ + "static/media/india.9ec8b782.svg";